import {
  GetCollaboratorCmSheetInternalGradeResponse,
  UpdateCollaboratorCmSheetInternalGradeRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetInternalGradeService = {
  async get(
    cmSheetId: number,
  ): Promise<GetCollaboratorCmSheetInternalGradeResponse> {
    const response =
      await httpClient.get<GetCollaboratorCmSheetInternalGradeResponse>(
        `v1/cm-sheets/${cmSheetId}/internal-grade`,
      );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCollaboratorCmSheetInternalGradeRequest,
  ): Promise<void> {
    await httpClient.put(`v1/cm-sheets/${cmSheetId}/internal-grade`, body);
  },
};

export default CmSheetInternalGradeService;
